import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
// import EloLogoAminated from '../../../images/Elo-Loader-Animated.svg';
import EloModal from 'src/images/Elo-Loader-Animated.svg'
import { border, borderRadius } from 'polished';
import { height } from '@mui/system';

interface LoadingModalProps {
    loading: boolean;
    title: string;
    message: string;    
}

function LoadingModal({ 
    loading,
    title,
    message
 }: LoadingModalProps) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 200,
    height: 200,
    bgcolor: '#bddc04',
    // border: '2px solid #000',
    borderRadius: '50%',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <Modal
      open={loading}
      aria-labelledby="loading"
      aria-describedby="loading"
    >
      <Box sx={style}>
        <EloModal />
        {/* <CircularProgress /> You can replace this with any other loader or text */}
      </Box>
    </Modal>
  );
}

export default LoadingModal;
